// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","landing":"App_landing__bdevK","mainLogin":"App_mainLogin__g4hiy"};